var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTwotoneDashboardCustomize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:twotone-dashboard-customize"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.3,
    d: "M25.3334 11.9999L20 11.9999L20 6.66659L25.3334 6.66659L25.3334 11.9999ZM25.3334 25.3333L20 25.3333L20 19.9999L25.3334 19.9999L25.3334 25.3333ZM12 25.3333L6.66671 25.3333L6.66671 19.9999L12 19.9999L12 25.3333Z",
    fill: "#22D3EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28 17.3333L17.3333 17.3333L17.3333 28L28 28L28 17.3333ZM25.3333 25.3333L20 25.3333L20 20L25.3333 20L25.3333 25.3333ZM14.6667 28L14.6667 17.3333L4 17.3333L4 28L14.6667 28ZM6.66667 20L12 20L12 25.3333L6.66667 25.3333L6.66667 20ZM28 4L17.3333 4L17.3333 14.6667L28 14.6667L28 4ZM25.3333 12L20 12L20 6.66667L25.3333 6.66667L25.3333 12ZM8 14.6667L10.6667 14.6667L10.6667 10.6667L14.6667 10.6667L14.6667 8L10.6667 8L10.6667 4L8 4L8 8L4 8L4 10.6667L8 10.6667L8 14.6667Z",
    fill: "#22D3EE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTwotoneDashboardCustomize);
export default __webpack_public_path__ + "static/media/ic_twotone-dashboard-customize.e46716aaba741321d3b7e8ef68448427.svg";
export { ForwardRef as ReactComponent };